import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatComponent } from './views/chat/chat.component';
import { AssistantsComponent } from './views/assistants/assistants.component';
import { ConversationsComponent } from './views/conversations/conversations.component';
import { AnalyticsComponent } from './views/analytics/analytics.component';
import { TestBenchRefactoredComponent } from './test-bench/test-bench-refactored.component';
import { PromptsComponent } from './views/prompts/prompts.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './common/auth.guard';
import { LoginRouteGuard } from './common/login.guard';
import { AgentsComponent } from './views/agents/agents.component';
import { SettingsComponent } from './views/settings/settings.component';
import { ProjectsComponent } from './views/projects/projects.component';
import { PromptListComponent } from './views/prompts/prompt-list/prompt-list.component';
import { AuthCallbackComponent } from './login/auth-callback.component';
import { UserProfileFormComponent } from './views/user/profile/profile.component';
import { SignupComponent } from './login/signup.component';
import { ThankYouComponent } from './login/thank-you.component';
import { ForgotPasswordComponent } from './login/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password.component';
import { WorkspacesComponent } from './views/workspaces/workspaces.component';
import { LogoutComponent } from './login/logout.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginRouteGuard],
    data: {},
  },
  {
    path: 'signup',
    component: SignupComponent,
    data: {},
  },
  {
    path: 'thank-you',
    component: ThankYouComponent,
    data: {},
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: {},
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: {},
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {},
  },
  {
    path: 'home',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {},
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {},
  },
  {
    path: 'chat',
    component: ChatComponent,
    canActivate: [AuthGuard],
    data: { chatType: 'chat' },
  },
  {
    path: 'tutors/chat/:id',
    component: ChatComponent,
    canActivate: [AuthGuard],
    data: { chatType: 'assistant' },
  },
  {
    path: 'tutors',
    component: AssistantsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'conversations/chat/:id',
    component: ChatComponent,
    canActivate: [AuthGuard],
    data: { chatType: 'conversation' },
  },
  {
    path: 'conversations',
    component: ConversationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'prompts',
    component: PromptsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'prompts/list',
    component: PromptListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'agents',
    component: AgentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'analytics',
    component: AnalyticsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workspaces',
    component: WorkspacesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'chat/:id',
    component: ChatComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'test',
    component: TestBenchRefactoredComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    component: UserProfileFormComponent,
    canActivate: [AuthGuard],
  },
  { path: 'auth/v1/callback', component: AuthCallbackComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes as Routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
